// Mock data for AKIWA landing page

export const brandInfo = {
  name: "AKIWA",
  tagline: "EXPERIENCE THE EDGE",
  phone: "98317 04400",
  email: "info@akiwa.tech",
  website: "akiwa.tech",
  address: "100/29, JESSORE ROAD, GROUND FLOOR, KOLKATA 700074"
};

export const productCategories = [
  {
    id: "pro",
    name: "AKIWA PRO",
    description: "Professional and business solutions for maximum impact",
    icon: "briefcase",
    color: "#000000"
  },
  {
    id: "home",
    name: "AKIWA HOME",
    description: "Premium home entertainment and comfort solutions",
    icon: "home",
    color: "#404040"
  },
  {
    id: "security",
    name: "AKIWA SECURITY",
    description: "Advanced security and surveillance systems",
    icon: "shield",
    color: "#606060"
  }
];

export const akiwaProProducts = [
  {
    id: "digital-standees",
    name: "Digital Standees",
    shortDesc: "Maximize Your Brand Impact",
    description: "High-resolution digital displays perfect for retail environments, exhibitions, and corporate spaces. Capture attention with dynamic content.",
    features: ["High Resolution Display", "Remote Content Management", "Energy Efficient", "Sleek Design"],
    category: "pro",
    image: "https://customer-assets.emergentagent.com/job_brochure-landing-1/artifacts/cycdkpc7_Digital-Standee.png"
  },
  {
    id: "farrata-fans",
    name: "Farrata Fans",
    shortDesc: "High Speed Cooling for Large Spaces",
    description: "Industrial-grade cooling solutions designed for warehouses, factories, and large commercial spaces.",
    features: ["High Speed Operation", "Energy Efficient Motor", "Durable Construction", "Wide Coverage Area"],
    category: "pro",
    image: "https://customer-assets.emergentagent.com/job_brochure-landing-1/artifacts/55t017zm_WhatsApp%20Image%202026-03-29%20at%2014.02.40.jpeg"
  },
  {
    id: "pro-projectors",
    name: "Professional Projectors",
    shortDesc: "Crystal Clear Presentations",
    description: "High-lumen projectors for conference rooms, auditoriums, and professional presentations.",
    features: ["4K Resolution", "High Brightness", "Wireless Connectivity", "Long Lamp Life"],
    category: "pro",
    image: "https://customer-assets.emergentagent.com/job_brochure-landing-1/artifacts/t9eqdobx_A10-720p-Portable-HD-Projector-1280X720-Resolution-Mini-Home-Projector-with-Electric-Focus-Adjustment-for-Home-Theater.jpg"
  },
  {
    id: "card-pen-drives",
    name: "Card Shaped Pen Drives",
    shortDesc: "Portable Brand Identity",
    description: "Customizable card-shaped USB drives perfect for marketing materials and corporate gifting.",
    features: ["Multiple Storage Options", "Custom Branding", "Slim Profile", "Durable Design"],
    category: "pro",
    image: "https://customer-assets.emergentagent.com/job_brochure-landing-1/artifacts/ztpwxjtx_WhatsApp%20Image%202026-03-29%20at%2014.08.15.jpeg"
  },
  {
    id: "logo-projectors",
    name: "Precision Logo Projectors",
    shortDesc: "Project Your Brand Anywhere",
    description: "Specialized projectors for displaying logos and branding at events, storefronts, and corporate spaces.",
    features: ["Sharp Logo Projection", "Adjustable Focus", "Compact Size", "Easy Installation"],
    category: "pro",
    image: "https://customer-assets.emergentagent.com/job_brochure-landing-1/artifacts/6nu0n6jt_WhatsApp%20Image%202026-03-29%20at%2014.06.10.jpeg"
  },
  {
    id: "compact-refrigerator",
    name: "50L Single Refrigerator",
    shortDesc: "Small capacity for compact spaces.",
    description: "A minimalist footprint intended to fit seamlessly under desks, inside cabinetry, or in compact corners.",
    features: ["Sleek Exterior Finish", "Reversible Door Configuration", "Integrated Thermal Control", "Low-Vibration Technology"],
    category: "pro",
    image: "https://customer-assets.emergentagent.com/job_brochure-landing-1/artifacts/hz3hv36n_WhatsApp%20Image%202026-03-29%20at%2014.43.44.jpeg"
  }
];

export const akiwaHomeProducts = [
  {
    id: "led-tvs",
    name: "LED TVs",
    shortDesc: "Cinematic Visuals in Your Home",
    description: "Experience stunning picture quality with our range of LED televisions featuring smart capabilities and immersive audio.",
    features: ["4K Ultra HD", "Smart TV Features", "HDR Support", "Multiple Screen Sizes"],
    category: "home",
    image: "https://customer-assets.emergentagent.com/job_brochure-landing-1/artifacts/y2ka078v_led%20tv.jpg"
  },
  {
    id: "bluetooth-speakers",
    name: "Bluetooth Speakers",
    shortDesc: "Premium Wireless Audio",
    description: "Portable speakers delivering exceptional sound quality for music lovers on the go.",
    features: ["360° Sound", "Long Battery Life", "Water Resistant", "Multi-Device Pairing"],
    category: "home",
    image: "https://customer-assets.emergentagent.com/job_brochure-landing-1/artifacts/b4tph26o_WhatsApp%20Image%202026-03-29%20at%2014.11.44%20%281%29.jpeg"
  },
  {
    id: "home-projectors",
    name: "Home Projectors",
    shortDesc: "Home Theater Experience",
    description: "Transform any room into a cinema with our high-quality home entertainment projectors.",
    features: ["Full HD Resolution", "Bright Output", "Built-in Speakers", "Easy Setup"],
    category: "home",
    image: "https://customer-assets.emergentagent.com/job_brochure-landing-1/artifacts/nxrpfck4_WhatsApp%20Image%202026-03-29%20at%2014.20.29.jpeg"
  },
  {
    id: "air-coolers",
    name: "Air Coolers",
    shortDesc: "Efficient Cooling Solution",
    description: "Eco-friendly air coolers providing effective cooling with minimal energy consumption.",
    features: ["High Cooling Capacity", "Low Power Consumption", "Large Water Tank", "Remote Control"],
    category: "home",
    image: "https://customer-assets.emergentagent.com/job_brochure-landing-1/artifacts/y2dhzb8d_air-coolers-250x250.jpg"
  },
  {
    id: "inverter-acs",
    name: "Inverter Air Conditioners",
    shortDesc: "Smart Climate Control",
    description: "Energy-efficient air conditioning with intelligent temperature management for year-round comfort.",
    features: ["Energy Saving Technology", "Silent Operation", "Auto Climate Control", "Air Purification"],
    category: "home",
    image: "https://customer-assets.emergentagent.com/job_brochure-landing-1/artifacts/uu8py130_WhatsApp%20Image%202026-03-29%20at%2014.14.47.jpeg"
  },
  {
    id: "portable-ac",
    name: "Portable Air Conditioner",
    shortDesc: "Flexible and easy to place.",
    description: "Experience the freedom of localized cooling without the need for permanent structural modifications.",
    features: ["Hot and cold mode", "Sleek, upright architecture", "Integrated filtration", "Plug and play"],
    category: "home",
    image: "https://customer-assets.emergentagent.com/job_brochure-landing-1/artifacts/bwexnpzk_WhatsApp%20Image%202026-03-29%20at%2015.08.59.jpeg"
  }
];

export const akiwaSecurityProducts = [
  {
    id: "cctv-cameras",
    name: "CCTV Cameras",
    shortDesc: "24/7 Security Monitoring",
    description: "Professional-grade CCTV systems with 2.4 MP resolution for comprehensive surveillance coverage.",
    features: ["2.4 MP Resolution", "Night Vision", "Motion Detection", "Remote Viewing"],
    category: "security",
    image: "https://customer-assets.emergentagent.com/job_brochure-landing-1/artifacts/qkt7gb1w_cctv-package.jpg"
  },
  {
    id: "drone-cameras",
    name: "Drone Cameras",
    shortDesc: "Aerial Surveillance Solutions",
    description: "Advanced drone technology for aerial monitoring, security assessment, and wide-area surveillance.",
    features: ["HD Camera", "GPS Navigation", "Long Flight Time", "Real-time Streaming"],
    category: "security",
    image: "https://customer-assets.emergentagent.com/job_brochure-landing-1/artifacts/tpm5o89k_WhatsApp%20Image%202026-03-29%20at%2014.23.42.jpeg"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    company: "Tech Solutions Pvt Ltd",
    role: "CEO",
    content: "AKIWA's digital standees have transformed our retail presence. The quality and reliability are outstanding!",
    rating: 5
  },
  {
    id: 2,
    name: "Priya Sharma",
    company: "Home User",
    role: "Homemaker",
    content: "The LED TV and air conditioner we purchased exceeded our expectations. Great picture quality and energy savings!",
    rating: 5
  },
  {
    id: 3,
    name: "Amit Patel",
    company: "Secure Spaces",
    role: "Security Manager",
    content: "AKIWA's CCTV systems provide crystal clear footage. The night vision is exceptional for our security needs.",
    rating: 5
  },
  {
    id: 4,
    name: "Sneha Gupta",
    company: "Creative Events",
    role: "Event Manager",
    content: "The professional projectors are perfect for our conferences. Bright, clear, and reliable every time.",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "What warranty do AKIWA products come with?",
    answer: "All AKIWA products come with comprehensive warranty coverage. Warranty periods vary by product category - typically 1-3 years for electronics and 5 years for air conditioners."
  },
  {
    id: 2,
    question: "Do you provide installation services?",
    answer: "Yes, we offer professional installation services for all our products including air conditioners, CCTV systems, and digital standees. Our certified technicians ensure proper setup and configuration."
  },
  {
    id: 3,
    question: "Can I customize products for my business?",
    answer: "Absolutely! We offer customization options for our professional range, especially digital standees, card-shaped pen drives, and logo projectors. Contact us to discuss your branding requirements."
  },
  {
    id: 4,
    question: "Where can I buy AKIWA products?",
    answer: "AKIWA products are available through our authorized dealers and our main showroom in Kolkata. You can also submit an inquiry through our website for purchasing information."
  }
];
